module.exports = __webpack_public_path__ + "static/media/google.e9e80780.svg";